<!--
 * @Date: 2022-08-04 16:29:35
 * @LastEditors: StavinLi
 * @LastEditTime: 2022-09-21 11:25:18
 * @FilePath: /Workflow/src/components/dialog/roleDialog.vue
-->
<template>
  <Modal
    title="选择角色"
    v-model="visibleDialog"
    width="800px"
    transfer
    class="promoter_role"
    :mask-closable="false"
  >
    <roleSelect
      v-if="visibleDialog"
      ref="roleSelect"
      :list.sync="list"
      :searchUseSelect="searchUseSelect"
      :multiple="true"
      :selectList.sync="selectList"
      :selectedIds.sync="selectedIds"
      :selectGroupIds.sync="selectGroupIds"
      :originData="originData"
      :customTreeList.sync="customTreeList"
      @on-select-change="onRoleSelectChange"
    />
    <span slot="footer" class="dialog-footer">
      <Button @click="$emit('update:visible', false)">取 消</Button>
      <Button type="primary" @click="saveDialog">确 定</Button>
    </span>
  </Modal>
</template>

<script>
import { roleSelect } from '@/components/personDepartmentRoleSelect';
import { getDepartmentSelect } from '@/api/workflow';
import mixins from './mixins';
export default {
  components: { roleSelect },
  mixins: [mixins],
  props: ['visible', 'selected'],
  watch: {
    visible(val) {
      this.visibleDialog = this.visible;
      if (val) {
        this.getDepartmentOption();
        console.log('selected ', this.selected);
      }
    },
    visibleDialog(val) {
      this.$emit('update:visible', val);
    }
  },
  computed: {},
  data() {
    return {
      visibleDialog: false,
      checkedRoleList: [],
      list: [],
      selectList: [],
      selectedIds: [],
      selectGroupIds: [],
      originData: [],
      customTreeList: [],
      searchUseSelect: []
    };
  },
  methods: {
    saveDialog() {
      this.$emit('change', this.selectList);
    },
    delList() {
      this.checkedRoleList = [];
    },
    async getDepartmentOption() {
      const res = await getDepartmentSelect();
      const { code, data } = res.data;
      if (code == 200) {
        if (Array.isArray(data) && data.length > 0) {
          this.searchUseSelect = data;
          const departmentId = data[0].id;
          const roleSelectDom = this.$refs['roleSelect'];
          roleSelectDom.selectModel = departmentId;
          this.getRoleList({ id: departmentId, selected: this.selected });
        }
      }
    },
    onRoleSelectChange(id) {
      this.getRoleList({ id, selected: this.selectList });
    }
  }
};
</script>

<style>
@import './dislogStyle/dialog.css';
</style>
